import { TextField } from "@mui/material";
import React from "react";

export default function TextFieldComponentMobile(props) {
  const isFieldEmpty = (value) => {
    return value === "" || value === null || value === undefined;
  };
  const handleChange = (event) => {
    props.onChange(event.target.value);
  };
  return (
    <div className="input-label-container-mobile-bis">
      <div className="input-label-mobile">{props.title}</div>
      <TextField
        style={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          marginTop: 7,
          border:
            props.showValidation && isFieldEmpty(props.value)
              ? "1px solid red"
              : "none",
        }}
        placeholder={props.placeholder}
        multiline
        rows={4}
        onChange={handleChange}
        value={props.value}
        error={props.showValidation && isFieldEmpty(props.value)} // Ajout de l'erreur MUI
        helperText={
          props.showValidation && isFieldEmpty(props.value)
            ? "This field is required"
            : ""
        } // Message d'aide si vide
      />
    </div>
  );
}
